import React from 'react';

import Legend from "../Legend";

export default function FormSection(props)
{

  return (
    <section id={props.id} className={`gc__section ${props.additionalClasses || ""}`}>
      <fieldset className={"gs__fieldset"}>
        { (typeof props.title != "undefined") ? (
          <Legend text={props.title} />
        ) : (<></>)}
        {props.children}
      </fieldset>
    </section>
  )
}
